export const getScaledImageBlobFromString = async (imageString, dimensions, maximumFileSizeInKb) => {
    return await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = dimensions.width;
            canvas.height = dimensions.height;
            ctx.drawImage(image, 0, 0, dimensions.width, dimensions.height);
            resolve(downScaleCanvas(canvas, maximumFileSizeInKb));
        };
        image.onerror = () => reject(new Error('Unable to load scaled down image.'));
        image.src = imageString;
    });
};
const downScaleCanvas = async (canvas, maximumFileSizeInKb) => {
    let quality = 1;
    let blob;
    do {
        blob = await new Promise(resolve => {
            canvas.toBlob((b) => resolve(b), 'image/jpeg', (quality -= 0.1));
        });
    } while (blob.size > convertKbToBytes(maximumFileSizeInKb));
    return blob;
};
const convertKbToBytes = (kb) => kb * 1000;
